module.exports = __webpack_public_path__ + "img/logo_fqm_preta.e1e57661.svg";